export const SURVEY_TYPE = {
  AIMI: 'aimi',
};
